module.exports = __webpack_public_path__ + "img/banner.aa11df2a.png";